// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__lRZxy","slide":"styles_slide__2SzVU","arrow":"styles_arrow__bBRCu","next":"styles_next__mFw6W","prev":"styles_prev__QK3Kd"};